import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById("root");

// The build-time prerender script (scripts/prerender.js) and the base public/index.html
// both ship static <title>/<meta description>/<link canonical>/OG/Twitter/geo tags and
// JSON-LD so non-JS crawlers see real content. react-helmet-async only ever ADDS tags —
// it has no way to recognise and replace tags it didn't render itself — so without this
// cleanup every page would end up with duplicate titles/descriptions/canonicals once
// Helmet mounts. Strip the static ones right before React takes over the page.
document.querySelectorAll(
  'title, meta[name="description"], link[rel="canonical"], meta[property^="og:"], meta[name^="twitter:"], meta[name^="geo."], script[type="application/ld+json"]'
).forEach((el) => el.remove());

const tree = (
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// react-snap hydrates prerendered HTML; regular loads use createRoot.
if (rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootEl, tree);
} else {
  ReactDOM.createRoot(rootEl).render(tree);
}
